module.exports = __webpack_public_path__ + "58e5ec185b5975680ad106100e9e6172.pdf";